/**
 * Cache module-level burro: guarda um valor e quando ele foi escrito, e diz
 * se ainda está dentro do prazo. Sem `Map`, sem chave, sem dedupe de
 * requisição concorrente — cada service usa a sua própria instância pra um
 * único recurso, que é o que `highlightsService.js` e `partnersService.js`
 * precisavam antes de duplicar o mesmo trio de variáveis.
 */
export const createTtlCache = (ttl) => {
  let value = null;
  let time = 0;

  return {
    read: () => (value !== null && Date.now() - time < ttl ? value : null),
    write: (v) => {
      value = v;
      time = Date.now();
    },
  };
};
